import assetPath from '/app/packages/lebenslauf/components/src/assets/open-sans-hebrew-regular.ttf';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')